import { render, staticRenderFns } from "./new-account.vue?vue&type=template&id=4c643b18&scoped=true&"
import script from "./new-account.vue?vue&type=script&lang=js&"
export * from "./new-account.vue?vue&type=script&lang=js&"
import style0 from "./new-account.vue?vue&type=style&index=0&id=4c643b18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c643b18",
  null
  
)

export default component.exports